const excludedItems = [
    'bottomless-peach-rubro',
    'rubro-new-countertop-bottomless',
    'bottomless-pepsi-max',
    'bottomless-tango-orange',
    'bottomless-pepsi-max-cherry',
    'bottomless-7-up-free',
    'bottomless-diet-pepsi',
    'bottomless-7-up-free-lime-and-mint',
    'pepsi',
    'diet-pepsi',
    'pepsi-max',
    'tango-orange',
    '7-up-free',
    'tap-water',
    /^fanta$/
]; //[/^rubro$/];

/**
 * Tiny function to exclude specific items from being displayed. Sometimes the API is not updated
 * as quickly as we'd like so this is used to remove items by slug.
 *
 * @function
 * @param    {[type]} slug [description]
 * @returns  {[type]}      [description]
 */
function excludedItem(slug) {
    return !!excludedItems.find((item) => {
        //console.log('slug item', slug, item, slug.match(item));
        return slug.match(item);
    });
}

export { excludedItem };
